/* eslint-disable @typescript-eslint/no-unused-vars */
import { ReactElement, ReactNode, PropsWithChildren } from 'react';
import classNames from 'classnames';

import './ErrorContainer.scss';
import Icon from '../Icon';

type Props = {
	content?: ReactNode;
	cssClass?: string;
	icon?: string;
	title?: string | boolean;
	html?: string;
};

export default function ErrorContainer({
	content,
	cssClass = 'GenericAppError',
	icon = 'alert',
	title = 'Error',
	children,
	html,
}: PropsWithChildren<Props>): ReactElement {
	return (
		<div className={classNames('AppError', cssClass)}>
			<div className="AppErrorIconWrapper">
				<Icon className="AppErrorIcon" icon={icon} />
			</div>

			<div className="AppErrorBody ty-b3">
				{title && (
					<div className="AppErrorTitle ty-c1">
						<span className="AppErrorTitleText">{title}</span>
					</div>
				)}

				{content}

				{html && <div dangerouslySetInnerHTML={{ __html: html }}></div>}
			</div>

			{children}
		</div>
	);
}
